/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NetCloudArrowUploadIcon16Light } from './NetCloudArrowUploadIcon16Light';
import { NetCloudArrowUploadIcon16Regular } from './NetCloudArrowUploadIcon16Regular';
import { NetCloudArrowUploadIcon16Solid } from './NetCloudArrowUploadIcon16Solid';
import { NetCloudArrowUploadIcon20Light } from './NetCloudArrowUploadIcon20Light';
import { NetCloudArrowUploadIcon20Regular } from './NetCloudArrowUploadIcon20Regular';
import { NetCloudArrowUploadIcon20Solid } from './NetCloudArrowUploadIcon20Solid';
import { NetCloudArrowUploadIcon24Regular } from './NetCloudArrowUploadIcon24Regular';
import { NetCloudArrowUploadIcon24Solid } from './NetCloudArrowUploadIcon24Solid';
import { NetCloudArrowUploadIcon32Regular } from './NetCloudArrowUploadIcon32Regular';
import { NetCloudArrowUploadIcon64Regular } from './NetCloudArrowUploadIcon64Regular';
var sizes = {
    16: {
        light: NetCloudArrowUploadIcon16Light,
        regular: NetCloudArrowUploadIcon16Regular,
        solid: NetCloudArrowUploadIcon16Solid,
    },
    20: {
        light: NetCloudArrowUploadIcon20Light,
        regular: NetCloudArrowUploadIcon20Regular,
        solid: NetCloudArrowUploadIcon20Solid,
    },
    24: {
        regular: NetCloudArrowUploadIcon24Regular,
        solid: NetCloudArrowUploadIcon24Solid,
    },
    32: {
        regular: NetCloudArrowUploadIcon32Regular,
    },
    64: {
        regular: NetCloudArrowUploadIcon64Regular,
    },
};
export var NetCloudArrowUploadIcon = forwardRef('NetCloudArrowUploadIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
